import type React from "react";
import { i18n } from "@frontend/i18n";

interface TopPicksInfoBannerProps {
  // The picks stay listed while a run rebuilds them, so the line explains them
  // as the previous set rather than introducing them as the current one.
  readonly recalculating: boolean;
}

export function TopPicksInfoBanner({
  recalculating,
}: TopPicksInfoBannerProps): React.JSX.Element {
  return (
    <p className="py-3 text-sm text-muted-foreground leading-tight">
      {i18n.t(
        recalculating
          ? "user.directory.topPicks.info.recalculating"
          : "user.directory.topPicks.info.description",
      )}
    </p>
  );
}
